import { compareAsc, compareDesc } from "date-fns";
import { match } from "ts-pattern";
import { z } from "zod";

import { type ListingsFilterKey, type ListingsFilterValue, type listingsSortByEnum } from "../trpc";
import { ForgeTNS } from "./types";

export const getSortedTNS = (
  thornames: ForgeTNS[],
  { sortBy }: { sortBy: z.infer<typeof listingsSortByEnum> | undefined },
) => {
  if (!sortBy) return thornames;

  return thornames?.toSorted((a, b) => {
    const [field, sortType] = sortBy.split(".") as [ListingsFilterKey, ListingsFilterValue];

    if (!field || !sortType) return 0;

    const isAsc = sortType === "asc";

    const result = match(field)
      .returnType<number>()
      .with("expiresAt", () =>
        isAsc
          ? compareAsc(a?.expiresAt || -1, b?.expiresAt || -1)
          : compareDesc(a?.expiresAt || -1, b?.expiresAt || -1),
      )
      .with("name", () =>
        isAsc ? a?.name?.localeCompare(b?.name) : b?.name?.localeCompare(a?.name),
      )
      .with("price", () => {
        return isAsc
          ? Number(a?.price?.rune || 0) - Number(b?.price?.rune || 0)
          : Number(b?.price?.rune || 0) - Number(a?.price?.rune || 0);
      })
      .otherwise(() => 0);

    return result;
  });
};
